// ⚠️ FICHIER ENGENDRÉ — NE PAS ÉDITER À LA MAIN.
// Source : lib/operateur-leviers.js + lib/leviers/*.js
// Régénérer : node scripts/generer-miroir-leviers.js
// Pourquoi ce doublon : CRA/webpack refuse les imports hors de src/ (Jest, lui,
// les accepte — d'où le risque de tests verts sur un build cassé).
// lib/leviers/_partage.js — CE QUE LA FORME ET LE REGISTRE LISENT TOUS LES DEUX.
//
// F5 (03/10/2026), forme décidée par Dimitri : une donnée se déclare à UN SEUL
// endroit, et ceux qui en ont besoin la LISENT — jamais une copie réécrite à
// la main. Jusqu'ici, les vagues existaient deux fois : la table `VAGUES` du
// registre (`lib/operateur-leviers.js`) et une liste recopiée dans le contrôle
// de forme (`_forme.js` : `[1, 2, 3, 4, 5, 6, 9, 10]`) ; une vague ajoutée d'un
// seul côté aurait fait refuser — ou accepter — un levier sans que l'autre le
// sache. Même chose pour `DITS_AU_CATALOGUE`, recopié dans les deux fichiers.
//
// ⚠️ CE FICHIER NE REQUIERT RIEN, ET C'EST SA RAISON D'ÊTRE. `_forme.js` tire
// `../app-carte.js`, qui n'a pas de miroir dans `src/` : le registre ne peut
// donc pas l'importer (le miroir navigateur casserait au build, tests verts).
// Ce fichier-ci, sans dépendance, est miroité dans `src/lib/leviers/` par
// `scripts/generer-miroir-leviers.js` comme les familles.

// Les vagues. Dimitri vérifie après chacune avant qu'on ouvre la suivante.
const VAGUES = Object.freeze({
  1: "propres et réversibles — la mécanique fait ses preuves",
  2: "rangement et clôtures",
  3: "contenu éditorial (livret, consignes)",
  4: "réglages bornés",
  // ⚠️ AJOUTÉE LE 2026-09-16 (décision Dimitri, chantier « les portes de
  // terrain »). « Sur ces écrans, il ne peut RIEN faire — même si je dis
  // oui » : les ménages, les incidents, le stock s'écrivaient depuis le
  // navigateur, sans action à composer. Cette vague porte les gestes du
  // quotidien qui ne quittent pas FBZ — déplacer un ménage, régler un
  // incident, recaler un stock. ⚠️ LIBELLÉ NEUTRE, SANS ÉNUMÉRATION : d'autres
  // lots y entrent (les tâches, #1445), et une parenthèse « (ménages,
  // incidents, stock) » serait fausse le lendemain. Fermée par défaut ; s'ouvre
  // par `OPERATEUR_GESTES_VAGUE` (« 5: » la rend candidate, « 5:nom » ouvre
  // un levier seul).
  5: "terrain — le quotidien qui ne sort pas",
  // ⚠️ AJOUTÉE LE 2026-09-17 (chantier « les portes de l'argent »). Dimitri :
  // « commence par ce que j'utilise : retirer ou remettre une réservation, les
  // ajustements. » Ces gestes corrigent un MOIS DE FACTURATION avant qu'il ne
  // soit facturé — ils ne touchent aucune pièce émise, et un mois déjà facturé
  // les refuse tous : le gel des mois facturés vit côté serveur.
  // (⚠️ Ne pas nommer ici le fichier du gel : une sentinelle vérifie qu'aucun
  // module `operateur-*` ne l'importe, et elle cherche la CHAÎNE, pas le
  // require — une mention en commentaire la ferait rougir à tort.)
  // ⚠️ VAGUE NEUVE, ET C'EST LA RAISON PRINCIPALE. Les vagues 1 à 4 et 9 sont
  // ouvertes en production : y ranger un geste d'argent l'aurait ouvert le
  // jour de sa fusion. Une vague neuve ne s'ouvre QUE nommée (« 6: » la rend
  // candidate, « 6:nom » ouvre un levier seul) — cf. SEUIL_HISTORIQUE dans
  // lib/operateur-intention.js, qui ne doit jamais l'accueillir.
  6: "l'argent du mois — corriger la facturation avant de l'émettre",
  9: "demande un texte que Dimitri écrit — en dernier, jamais exclu",
  // ⚠️ AJOUTÉE LE 2026-09-15 (décision Dimitri, chantier « les formulaires en
  // conversation »). Les vagues 1 à 9 règlent, publient, répondent ; celle-ci
  // fait EXISTER quelque chose — inscrire un propriétaire, inscrire un
  // logement. Rien de comparable n'y entrait, et la glisser dans une vague
  // déjà vérifiée aurait ouvert une création sans que personne l'ait décidé.
  10: "les formulaires — ce qui CRÉE (un propriétaire, un logement)",
});

// Trois suffisent au catalogue : au-delà, on paye du prompt pour des synonymes.
const DITS_AU_CATALOGUE = 3;

module.exports = { VAGUES, DITS_AU_CATALOGUE };
